module.exports = __webpack_public_path__ + "static/media/3.06274823.jpg";